import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter as Router } from 'react-router-dom'
import { initDva, initRequest, bindJWTToken } from './dva16'
import modelArray from './models'
import { message } from 'antd'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import Home from './pages/main'

const ENV = process.env

initDva(modelArray, { useImmer: false, printLog: false })
//
// initRequest('http://s.kollok.cn/k3/client/v1/', (status, data) => {
// initRequest('http://s.stgame.cn/k3/client/v1/', (status, data) => {
initRequest(ENV.NODE_ENV === 'development' ? 'http://127.0.0.1:10315/client/v1/' : 'http://s.kollok.cn/k3/client/v1/', (status, data) => {
  console.log(status, 'aaaaaaaaa')
  if (status === 401) {
    window.location.href = '#/login'
    return
  }
  if (status === 400) {
    if (data.error === 1004) {
      message.config({ maxCount: 1 })
      message.error(data.message)
      window.location.href = '#/login'
      return
    }
  }
  if (status !== 200) {
    message.error(data.message)
  }
})

let token = localStorage.getItem('k3Token')
if (token) {
  bindJWTToken(token)
}

// bindJWTToken('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySUQiOjEsImlhdCI6MTU4NDYxMTUzNH0.-wzDGDcY_EVr5O4_wzgnwe1f-x6Sr1EYltX8hRjhYMk')

export default function App() {
  return (
    <Router>
      <Home />
    </Router>
  )
}
ReactDOM.render(<App />, document.getElementById('root'))
